var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconHospitalBuilding2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Regular",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "hospital-house"), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.75,12.75v9a1.5,1.5,0,0,0,1.5,1.5h13.5a1.5,1.5,0,0,0,1.5-1.5v-9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23.25 11.25 12 0.75 0.75 11.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.5,13.5a.75.75,0,0,0-.75-.75H13.5V10.5a.75.75,0,0,0-.75-.75h-1.5a.75.75,0,0,0-.75.75v2.25H8.25a.75.75,0,0,0-.75.75V15a.75.75,0,0,0,.75.75H10.5V18a.75.75,0,0,0,.75.75h1.5A.75.75,0,0,0,13.5,18V15.75h2.25A.75.75,0,0,0,16.5,15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconHospitalBuilding2);
export default __webpack_public_path__ + "static/media/streamline-icon-hospital-building-2.3d7843f6.svg";
export { ForwardRef as ReactComponent };